import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { usePermission } from '@/hooks/usePermission';
import { useAppSelector } from '@/hooks/useAppSelector';
import { AppRoutes } from '@/constants/routes';

interface ProtectedRouteProps {
  requiredPermission?: string;
}

export const ProtectedRoute = ({ requiredPermission }: ProtectedRouteProps) => {
  const { isAuthenticated } = useAuth();
  const { hasPermission }   = usePermission();
  const location            = useLocation();
  const forcePasswordChange = useAppSelector((s) => s.auth.user?.forcePasswordChange);

  if (!isAuthenticated) {
    return <Navigate to={AppRoutes.LOGIN} state={{ from: location }} replace />;
  }

  // Intercept any navigation attempt while a forced password change is pending.
  // Allow the change-password route itself so it doesn't create an infinite redirect.
  if (forcePasswordChange && location.pathname !== AppRoutes.CHANGE_PASSWORD) {
    return <Navigate to={AppRoutes.CHANGE_PASSWORD} replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to={AppRoutes.ACCESS_DENIED} replace />;
  }

  return <Outlet />;
};
